import React from 'react';
import { withGoogleMap, GoogleMap, Marker, Polygon } from 'react-google-maps';
import _ from 'lodash';

// return marker coords from port/area
// only first coordinates taken from area polygons
function computeCoords(areasOrCords, type) {
    if (type === 'area') {
        return areasOrCords.map((item) => {
            if (item.coordinates) {
                return {
                    lat: parseFloat(item.coordinates[1]),
                    lng: parseFloat(item.coordinates[0]),
                };
            } else if (item.areaCoordinatesPolygons && item.areaCoordinatesPolygons.coordinates) {
                const polygon = item.areaCoordinatesPolygons.coordinates[0];
                if (!polygon) {
                    return;
                }
                const point = polygon[0][0];
                return {
                    lat: parseFloat(point[1]),
                    lng: parseFloat(point[0]),
                };
            }
        }).filter(p => p);
    } 
    return [{
        lat: parseFloat(areasOrCords[1]),
        lng: parseFloat(areasOrCords[0]),
    }];
}

class Map extends React.Component {
    constructor(props) {
        super(props);

        const { coordinates, type, areaPolygon } = props;
        this.state = {
            coordinates: computeCoords(coordinates, type),
            areaPolygon,
        };
    }

    makeBounds() {
        const { coordinates } = this.state;

        if (coordinates.length === 0) {
            return;
        }

        const bounds = new google.maps.LatLngBounds();

        coordinates.forEach((item) => {
            bounds.extend(item);
        });

        if (this.props.type !== 'ports') {
            this.refs.googleMap.fitBounds(bounds);
        }
    }

    componentDidMount() {
        this.makeBounds();
    }

    componentDidUpdate() {
        google.maps.event.trigger(this.refs.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, 'resize');
        this.makeBounds();
    }

    UNSAFE_componentWillReceiveProps({ coordinates, type, areaPolygon }) {
        this.setState({
            coordinates: computeCoords(coordinates, type),
            areaPolygon,
        });

        if (areaPolygon) {
            const poly = new google.maps.Polygon({
                paths: areaPolygon,
            });

            const bounds = new google.maps.LatLngBounds();
            const paths = poly.getPaths();
            let path;        
            for (let i = 0; i < paths.getLength(); i++) {
                path = paths.getAt(i);
                for (let ii = 0; ii < path.getLength(); ii++) {
                    bounds.extend(path.getAt(ii));
                }
            }

            this.refs.googleMap.fitBounds(bounds);
        }
    }

    render() {
        const { coordinates, areaPolygon } = this.state;
        const { editCoordsMarker } = this.props;
        return (<div>
            {
                <GoogleMap
                    ref='googleMap'
                    defaultZoom={10}
                    zoom={10}
                    defaultCenter={{
                        lat: coordinates[0] ? coordinates[0].lat : 0,
                        lng: coordinates[0] ? coordinates[0].lng : 0,
                    }}
                >
                    {
                        coordinates.map((item, key) => (<Marker
                            key={key}
                            position={{
                                lat: item.lat,
                                lng: item.lng,
                            }}
                        />))
                    }
                    {
                        areaPolygon &&
                        <Polygon 
                            path={areaPolygon.map((point) => {
                                if (point.lng || point.lat) {
                                    if (point.lng && point.lat) {
                                        return point;
                                    }
                                    return {};
                                }
                                return {
                                    lat: point[1],
                                    lng: point[0],
                                };
                            })}
                            options={{
                                strokeColor: '#00f',
                                fillColor: '#00f',
                            }}
                        />
                    }
                    {
                        areaPolygon && (editCoordsMarker || editCoordsMarker === 0) &&
                        <Marker
                            position={areaPolygon[editCoordsMarker]}
                        />
                    }
                </GoogleMap>
            }
        </div>);
    }
}

const MyMapComponent = withGoogleMap(Map);

export default MyMapComponent;



// WEBPACK FOOTER //
// ./app/components/Regions/Merging/Map.jsx